import React, { useEffect } from 'react';

import AdminDashboardComponent from '../../components/AdminDashboard';
import useTransactionsList from '../../hooks/useTransactionsList';

import * as S from './styled';

function AdminDashboardContainer() {
  const [
    { state, listRef, infiniteLoaderRef },
    { fetchTransactions, isItemLoaded, fetchTransactionsMeta, onChangeFilter },
  ] = useTransactionsList();

  useEffect(() => {
    fetchTransactionsMeta({
      shouldMarkAsLoading: true,
      shouldReloadListIfChange: false,
    });
  }, []);

  if (state.isLoading) {
    return <div>Loading</div>;
  }

  return (
    <S.AdminDashboard>
      <AdminDashboardComponent
        totalIncome={state.totalIncome}
        transactionsCount={state.transactionsCount}
        transactions={state.transactions}
        workspaces={state.workspaces}
        listItems={state.listItems}
        dayPoints={state.dayPoints}
        filter={state.filter}
        loadMoreTransactions={fetchTransactions}
        isItemLoaded={isItemLoaded}
        onChangeFilter={onChangeFilter}
        listRef={listRef}
        infiniteLoaderRef={infiniteLoaderRef}
      />
    </S.AdminDashboard>
  );
}

AdminDashboardContainer.propTypes = {};

export default AdminDashboardContainer;
